<template>
  <v-app dir="rtl">
    <router-view />
  </v-app>
</template>

<script>
export default {
  name: 'AppComponent'
}
</script>

<style>
@import url('https://fonts.googleapis.com/css2?family=Cairo:wght@300;400;500;600;700&display=swap');

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  font-family: 'Cairo', sans-serif;
}

:root {
  --primary-color: #575D90;
  --primary-light: #7780b4;
  --primary-dark: #3e4266;
  --secondary-color: #f5f5f5;
  --text-color: #333;
  --text-light: #666;
  --danger-color: #dc3545;
  --success-color: #28a745;
  --warning-color: #ffc107;
  --info-color: #17a2b8;
}

body {
  background-color: #f8f9fa;
  color: var(--text-color);
  direction: rtl;
}

.app-container {
  min-height: 100vh;
}

/* Global font settings */
* {
  font-family: 'Cairo', sans-serif !important;
}

/* Ensure Vuetify components use the font */
:deep(.v-application) {
  font-family: 'Cairo', sans-serif !important;
}

.v-application [class*='text-'] {
  font-family: 'Cairo', sans-serif !important;
}

.v-application .v-btn,
.v-application .v-card-title,
.v-application .v-card-text,
.v-application .v-list-item-title,
.v-application .v-list-item-subtitle,
.v-application .v-data-table,
.v-application .v-label,
.v-application input,
.v-application textarea,
.v-application .v-select,
.v-application .v-chip {
  font-family: 'Cairo', sans-serif !important;
}
</style>
